import React, { useState } from 'react';
import PropTypes from 'prop-types';
import __ from '../../helpers/translation';

const propTypes = {
};

function SublocationFailedConfirmationFeedbackModal(props) {

    const confirm = (e) => {
        window.$('#sublocationFailedConfirmFeedback').modal('hide');
        return;
    }

    return (

        <div className="modal fade" id="sublocationFailedConfirmFeedback" tabIndex="-1" role="dialog" aria-labelledby="confirmsublocationfailed" aria-hidden="true">
            <div className="modal-dialog modal-lg modal-dialog-centered" role="document">
                <div className="modal-content p-3 p-sm-5">
                    <div className="modal-header">
                        <h1 className="modal-title fw-600">{ __('app.inspections.confirm_sublocation_failed_title') }</h1>
                        <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div className="modal-body">
                        <p>
                            { __('app.inspections.confirm_sublocation_failed_message') }
                        </p>
                        <button onClick={(e) => confirm()}
                            className="btn btn-black d-block w-100 mt-2">
                            { __('app.general.close_menu') }
                        </button>
                    </div>
                </div>
            </div>
        </div>

    )
}

SublocationFailedConfirmationFeedbackModal.propTypes = propTypes;

export default SublocationFailedConfirmationFeedbackModal;